export default {"src":"/_next/static/media/Dog-Heart.79a02830.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};